import type { ReactNode } from 'react';
import { Role } from 'src/models/user';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import PaymentOutlined from '@mui/icons-material/PaymentOutlined';
import ReportTwoToneIcon from '@mui/icons-material/AddchartTwoTone';
import ReceiptIcon from '@mui/icons-material/ReceiptOutlined';
import ChecklistIcon from '@mui/icons-material/FactCheckOutlined';
import AssignmentIndOutlined from '@mui/icons-material/AssignmentIndOutlined';
import DashboardOutlined from '@mui/icons-material/DashboardOutlined';
import ViewListOutlinedIcon from '@mui/icons-material/ViewListOutlined';
import ManageSupervisorOutlinedIcon from '@mui/icons-material/SupervisorAccount';
import MessageOutlinedIcon from '@mui/icons-material/MessageOutlined';
import ReportOutlinedIcon from '@mui/icons-material/AutoGraphOutlined';
import PointOfSaleTwoToneIcon from '@mui/icons-material/PointOfSaleTwoTone';

export interface MenuItem {
    link?: string;
    icon?: ReactNode;
    badge?: string;
    badgeTooltip?: string;

    items?: MenuItem[];
    name: string;
}

export interface MenuItems {
    items: MenuItem[];
    heading?: string;
    permission: string[];
}


const menuItems: MenuItems[] = [
    {
        permission: [Role.AGENT],
        items: [
            {
                name: 'Agent',
                icon: DashboardOutlined,
                link: '/jpl/agent/dashboard',
                items: [
                    {
                        name: 'Agent Dashboard',
                        link: '/jpl/agent/dashboard',
                        icon: DashboardOutlined
                    },
                    {
                        name: 'Followup',
                        link: '/jpl/agent/followup',
                        icon: ViewListOutlinedIcon
                    },
                    {
                        name: 'Report',
                        link: '/jpl/agent/report',
                        icon: ReportOutlinedIcon
                    },
                ]
            }
        ]
    },
    {
        permission: [Role.SUPER, Role.ADMIN],
        items: [
            {
                name: 'Dashboard',
                icon: DashboardOutlined,
                link: '/jpl/dashboard',
                items: [
                    {
                        name: 'Admin Dashboard',
                        link: '/jpl/dashboard/admin',
                        icon: DashboardOutlined
                    },
                    {
                        name: 'User Dashboard',
                        link: '/jpl/dashboard/user',
                        icon: ViewListOutlinedIcon
                    }
                ]
            }
        ]
    },
    
    {
        permission: [Role.ADMIN, Role.SUPER],
        items: [
            {
                name: 'Administration',
                icon: SettingsOutlinedIcon,
                link: '',
                items: [
                    {
                        name: 'Manage Users',
                        link: '/jpl/configuration/users',
                        icon: ManageAccountsOutlinedIcon
                    },
                    {
                        name: 'Manage Services',
                        link: '/jpl/configuration/services',
                        icon: ManageSupervisorOutlinedIcon
                    }

                ]
            }
        ]
    },
    {
        permission: [Role.RECEPTIONIST, Role.CASHIER],
        items: [
            {
                name: 'Reception',
                icon: ReceiptIcon,
                link: '',
                items: [
                    {
                        name: 'Manage Client Register',
                        link: '/jpl/reception/register',
                        icon: ManageAccountsOutlinedIcon
                    },
                    {
                        name: 'Check-in',
                        link: '/jpl/reception/check-in',
                        icon: ChecklistIcon
                    },
                    {
                        name: 'payment',
                        link: '/jpl/reception/payment',
                        icon: PointOfSaleTwoToneIcon
                    },
                    // {
                    //     name: 'report',
                    //     link: '/jpl/reception/report',
                    //     icon: ReportTwoToneIcon
                    // }
                ]
            },

        ]
    },
    {
        permission: [Role.ADMIN, Role.CASHIER,Role.AGENT,Role.SUPER,Role.RECEPTIONIST],
        items: [
            {
                name: 'Messenger',
                icon: MessageOutlinedIcon,
                link: '/jpl/configuration/messenger',
              
            },

        ]
    },
    {
        permission: [Role.CLIENT],
        items: [
            {
                name: 'Messenger',
                icon: MessageOutlinedIcon,
                link: '/jpl/configuration/messenger',
              
            },

        ]
    },
];

export default menuItems;
